import { render } from "./TouchEdit.vue?vue&type=template&id=678ddca7"
import script from "./TouchEdit.vue?vue&type=script&lang=js"
export * from "./TouchEdit.vue?vue&type=script&lang=js"

import "./TouchEdit.vue?vue&type=style&index=0&id=678ddca7&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__